// extracted by mini-css-extract-plugin
module.exports = {"dueDateItem":"paymentusagedetail_dueDateItem__3OM_S","btnCol":"paymentusagedetail_btnCol__37og4"};